import {
  AccessDeniedError,
  BadRequestError,
  ConnectionError,
  HttpTypes,
  InternalServerError,
  TooManyRequestsError,
  UnexpectedError,
} from 'src/http';
import { httpResponseHandler } from 'src/http/http-response-handler';
import { ScnEventType } from 'src/types/scn-events';
import { Either } from 'src/utils/either';

export class ScnEventsRepository {
  constructor(private readonly api: HttpTypes.HttpClient) {}

  async getScnEventsList(): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        ScnEventType[]
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `benefits/scn-events/all`,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getScnEventDetails(
    id: string
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        ScnEventType
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `benefits/scn-events/details`,
      params: { id },
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async createScnEvent(
    scnEvent: any
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        ScnEventType
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: `benefits/scn-events/create`,
      body: scnEvent,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async updateScnEvent(
    id: string,
    scnEvent: any
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        ScnEventType
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: `benefits/scn-events/update`,
      params: { id },
      body: scnEvent,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
